import Button from '@mui/material/Button';
import styles from './StoriesListEmptyView.scss';
import React from 'react';
import { IStoryListMessages, IStoryListSelection } from '../../../../types/storyListTypes';

type IStoriesListEmptyView = {
  storyMessages: IStoryListMessages;
  selectedSectionId: string;
  clearSearchFilters: () => void;
  setSelectedSection: (section: IStoryListSelection, viewtype?: string) => void;
};

export const StoriesListEmptyView = (props: IStoriesListEmptyView): JSX.Element => {
  const { storyMessages, clearSearchFilters, selectedSectionId, setSelectedSection } = props;
  return (
    <div className={styles.noStoriesFoundContainer}>
      <h1 data-test="stories-none-found-heading">{storyMessages.noStoriesFound}</h1>
      <h2>{!!selectedSectionId ? storyMessages.adjustFiltersInFolder : storyMessages.adjustFilters}</h2>
      <div className={styles.filterResultButtons}>
        <Button size="large" variant="outlined" color="secondary" onClick={clearSearchFilters} data-test="clear-filters-button">
          {storyMessages.clearFilters}
        </Button>
        {!!selectedSectionId && (
          <div className={styles.allStoryButton}>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={() => {
                clearSearchFilters();
                void setSelectedSection(null);
              }}
              data-test="view-all-stories-button"
            >
              {storyMessages.viewAllStories}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
